
import SparepartEdit from "./sparepart/sparepart-edit";
import SparepartList from "./sparepart/sparepart-list";

const sparepartRoutes = [
    { path: "/sparepart/sparepart", element: <SparepartList /> },
    { path: "/sparepart/sparepart-edit", element: <SparepartEdit /> },
    // { path: "/sparepart/sparepart-view", element: <SparepartView /> },
];


export default sparepartRoutes;
